import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M6.744 3.683c.425-.055.801.07 1.084.189s.625.301.995.499l9.983 5.325.021.01 1.06.6c.271.178.611.439.803.854a2 2 0 0 1 0 1.677c-.192.415-.532.677-.804.855-.28.184-.651.382-1.064.602l-10 5.333-.995.5c-.283.119-.66.243-1.084.188a2 2 0 0 1-1.374-.824c-.248-.349-.315-.739-.343-1.045S5 17.754 5 17.334V6.667l.027-1.113c.028-.306.095-.698.343-1.047a2 2 0 0 1 1.374-.823zM7 17.334l.019.931.004.029c.009-.004.02-.005.03-.01a11.86 11.86 0 0 0 .829-.421l10-5.334.906-.507c.011-.008.02-.017.03-.023l-.029-.021c-.184-.121-.457-.267-.903-.505v-.001L7.882 6.137l-.83-.422-.029-.011-.004.031c-.018.196-.019.472-.019.931v10.667z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "play"}) } }